export default __webpack_public_path__ + "images/my-0d298a9e4566332f8a840d388fa6db2d.svg";